import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1.5),
  py: theme.spacing(6),
  px: theme.spacing(3),
  borderRadius: 3,
  border: `2px dashed ${theme.palette.divider}`,
  bgcolor: "background.paper",
  textAlign: "center",
});

export const title: SxProps<Theme> = {
  fontWeight: 600,
  color: "text.secondary",
};

export const description: SxProps<Theme> = {
  maxWidth: 360,
  color: "text.disabled",
  lineHeight: 1.7,
};
